/* TRIO – Page « Avis clients » */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function sized(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function countTo(el, to, dec, ms) {
    if (reduce) return;
    var t0 = null;
    function f(v) { return dec ? v.toFixed(dec).replace('.', ',') : String(Math.round(v)); }
    el.textContent = f(0);
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3);
      el.textContent = f(to * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = f(to);
    }
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = f(to); }, ms + 400);
  }

  function boot(root) {
    if (root.__tav) return;
    root.__tav = true;

    var grid = $('[data-tav-grid]', root);
    if (!grid) return;
    var cards = $$('[data-tav-card]', grid);
    /* rythme du mur : deux avis photo, un avis texte, puis les notes seules */
    (function mix() {
      var P = [], T = [], M = [], out = [];
      cards.forEach(function (c) { (c.dataset.ph === '1' ? P : c.classList.contains('is-mini') ? M : T).push(c); });
      /* les avis texte les plus détaillés d'abord */
      T.sort(function (x, y) { return txt($('[data-tav-t]', y)).length - txt($('[data-tav-t]', x)).length; });
      while (P.length || T.length) {
        if (P.length) out.push(P.shift());
        if (T.length) out.push(T.shift());
        if (P.length) out.push(P.shift());
      }
      cards = out.concat(M);
    })();
    var byId = {};
    cards.forEach(function (c) { byId[c.dataset.id] = c; });

    /* ---------- Héro : entrée + chiffres ---------- */
    if (!reduce) {
      root.classList.add('is-armed');
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('is-armed'); root.classList.add('is-ready'); }); });
      var avg = $('[data-tav-avg]', root), tot = $('[data-tav-total]', root);
      setTimeout(function () {
        if (avg) countTo(avg, parseFloat(avg.dataset.tavAvg) || 0, 1, 1300);
        if (tot) countTo(tot, parseInt(tot.dataset.tavTotal, 10) || 0, 0, 1300);
      }, 250);
    }

    /* ---------- Héro : paquet de photos + citations ---------- */
    (function deck() {
      var wrap = $('[data-tav-deck]', root);
      if (!wrap) return;
      var slides = cards.filter(function (c) {
        if (c.dataset.ph !== '1') return false;
        var l = txt($('[data-tav-t]', c)).length;
        return l >= 40 && l <= 150;
      }).map(function (c) {
        var img = $('.tav-card__ph img', c);
        return { src: sized(img && img.getAttribute('src'), 800), t: txt($('[data-tav-t]', c)), n: txt($('.tav-who b', c)), m: txt($('.tav-model', c)) };
      });
      if (slides.length < 3) { wrap.hidden = true; return; }
      var frames = $$('.tav-deck__f', wrap), q = $('[data-tav-quote]', wrap);
      var qt = $('[data-tav-qt]', q), qn = $('[data-tav-qn]', q), qm = $('[data-tav-qm]', q), bar = $('[data-tav-qbar]', q);
      var i = 0, timer = 0, paused = false, inView = true, D = 5500;
      frames.forEach(function (f, k) { $('img', f).src = slides[k].src; });
      function quote(s) { qt.textContent = '« ' + s.t + ' »'; qn.textContent = s.n; qm.textContent = s.m ? '· ' + s.m : ''; }
      quote(slides[0]);
      function runBar() {
        bar.classList.remove('is-run'); void bar.offsetWidth;
        bar.style.setProperty('--d', D + 'ms'); bar.classList.add('is-run');
      }
      function next() {
        root.classList.add('is-cycling');
        i = (i + 1) % slides.length;
        var front = frames.filter(function (f) { return f.dataset.pos === '0'; })[0];
        frames.forEach(function (f) {
          if (f.dataset.pos === '1') f.dataset.pos = '0';
          else if (f.dataset.pos === '2') f.dataset.pos = '1';
        });
        front.dataset.pos = 'out';
        setTimeout(function () {
          front.style.transition = 'none';
          front.dataset.pos = '2';
          $('img', front).src = slides[(i + 2) % slides.length].src;
          void front.offsetWidth; front.style.transition = '';
        }, 650);
        q.classList.add('is-swap');
        setTimeout(function () { quote(slides[i]); q.classList.remove('is-swap'); }, 420);
        runBar();
      }
      function loop() {
        clearTimeout(timer);
        if (reduce || paused || !inView || document.hidden) { bar.classList.remove('is-run'); return; }
        runBar();
        timer = setTimeout(function tick() { next(); timer = setTimeout(tick, D); }, D);
      }
      wrap.addEventListener('mouseenter', function () { paused = true; loop(); });
      wrap.addEventListener('mouseleave', function () { paused = false; loop(); });
      document.addEventListener('visibilitychange', loop);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; loop(); }, { threshold: .2 }).observe(wrap);
      }
      setTimeout(loop, reduce ? 0 : 1200);
    })();

    /* ---------- Bandeau photos ---------- */
    (function strip() {
      var run = $('[data-tav-strip]', root);
      if (!run) return;
      var sec = run.closest('.tav-strip'), track = run.firstElementChild, items = $$('.tav-strip__it', track);
      if (!reduce && items.length > 4) {
        items.forEach(function (it) {
          var c = it.cloneNode(true);
          c.setAttribute('tabindex', '-1'); c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        });
        sec.style.setProperty('--dur', Math.max(40, items.length * 2.6) + 's');
        sec.classList.add('is-moving');
      }
      track.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tav-photo]');
        if (b) openLb(b.dataset.tavPhoto, true);
      });
    })();

    /* ---------- Filtres, pagination, mosaïque ---------- */
    var per = parseInt(grid.dataset.per, 10) || 12;
    if (window.innerWidth < 750) per = Math.min(per, 8);
    var filter = 'all', shown = per, cols = [], ncols = 0, placed = [];
    var status = $('[data-tav-status]', root), more = $('[data-tav-loadmore]', root);
    var fbtns = $$('[data-tav-filters] button', root);
    var labels = { all: 'avis', photo: 'avis avec photo', prime: 'avis Trio Prime', original: 'avis Trio Original', evo: 'avis Trio Evo', moov: 'avis Trio Moov' };

    function match(c) {
      if (filter === 'all') return true;
      if (filter === 'photo') return c.dataset.ph === '1';
      return c.dataset.m === filter;
    }
    function list() { return cards.filter(match); }
    function colCount() { return window.innerWidth >= 1100 ? 3 : window.innerWidth >= 750 ? 2 : 1; }

    function clampCheck(c) {
      var t = $('[data-tav-t]', c), b = $('[data-tav-more]', c);
      if (!t || !b || b.dataset.done) return;
      t.classList.add('is-clamp');
      if (t.scrollHeight - t.clientHeight > 4) { b.hidden = false; }
      else { t.classList.remove('is-clamp'); b.hidden = true; }
      b.dataset.done = '1';
    }
    function place(c, k) {
      var best = cols[0];
      for (var j = 1; j < cols.length; j++) if (cols[j].offsetHeight < best.offsetHeight - 1) best = cols[j];
      best.appendChild(c);
      placed.push(c);
      clampCheck(c);
      if (k != null && !reduce) {
        c.classList.remove('is-new'); void c.offsetWidth;
        c.style.setProperty('--dl', Math.min(k, 8) * 0.05 + 's');
        c.classList.add('is-new');
      }
    }
    function build(animate) {
      ncols = colCount();
      grid.classList.add('is-masonry');
      grid.textContent = '';
      cols = []; placed = [];
      for (var j = 0; j < ncols; j++) { var d = document.createElement('div'); d.className = 'tav-col'; grid.appendChild(d); cols.push(d); }
      list().slice(0, shown).forEach(function (c, k) { place(c, animate ? k : null); });
      update();
    }
    function update() {
      var all = list().length;
      var n = Math.min(shown, all);
      var lab = labels[filter] || 'avis';
      if (status) status.textContent = n >= all ? (all > 1 ? 'Les ' + all + ' ' + lab + ' sont affichés' : '1 avis affiché') : n + ' sur ' + all + ' ' + lab + ' affichés';
      if (more) {
        more.hidden = n >= all;
        more.textContent = 'Voir plus d’avis (' + (all - n) + ')';
      }
    }
    if (more) more.addEventListener('click', function () {
      var l = list(), from = Math.min(shown, l.length);
      shown += per;
      l.slice(from, shown).forEach(function (c, k) { place(c, k); });
      update();
      var first = l[from];
      if (first) { var b = first.querySelector('button, a'); if (b) b.focus({ preventScroll: true }); }
    });
    fbtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.f === filter) return;
        filter = b.dataset.f; shown = per;
        fbtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        build(true);
        var top = $('.tav-bar', root).getBoundingClientRect().top;
        if (top < 0) $('.tav-bar', root).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    var rz = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { if (colCount() !== ncols) build(false); }, 150);
    });
    grid.addEventListener('click', function (e) {
      var m = e.target.closest('[data-tav-more]');
      if (m) {
        var t = m.parentNode.querySelector('[data-tav-t]'), open = m.getAttribute('aria-expanded') === 'true';
        t.classList.toggle('is-clamp', open);
        m.setAttribute('aria-expanded', open ? 'false' : 'true');
        m.textContent = open ? 'Lire la suite' : 'Réduire';
        return;
      }
      var o = e.target.closest('[data-tav-open]');
      if (o) openLb(o.closest('[data-tav-card]').dataset.id, false, o);
    });
    build(false);

    /* ---------- Visionneuse ---------- */
    var lb = $('[data-tav-lb]', root), lbList = [], lbI = 0, lbFrom = null;
    var lbImg = lb && $('[data-tav-lbimg]', lb);
    function fill() {
      var c = lbList[lbI], img = $('.tav-card__ph img', c);
      var src = sized(img.getAttribute('src'), 1400);
      lbImg.classList.add('is-load');
      lbImg.onload = function () { lbImg.classList.remove('is-load'); };
      lbImg.src = src;
      lbImg.alt = img.alt || '';
      var t = $('[data-tav-t]', c);
      $('[data-tav-lbt]', lb).innerHTML = t ? t.innerHTML : '';
      $('[data-tav-lbrate]', lb).style.setProperty('--f', $('.tav-rate', c).style.getPropertyValue('--f'));
      $('[data-tav-lbrate]', lb).setAttribute('aria-label', $('.tav-rate', c).getAttribute('aria-label'));
      $('[data-tav-lbft]', lb).innerHTML = $('.tav-card__ft', c).innerHTML;
      $('[data-tav-lbn]', lb).textContent = 'Photo ' + (lbI + 1) + ' sur ' + lbList.length;
      var nx = lbList[(lbI + 1) % lbList.length];
      if (nx) { var pre = new Image(); pre.src = sized($('.tav-card__ph img', nx).getAttribute('src'), 1400); }
    }
    function go(d) { lbI = (lbI + d + lbList.length) % lbList.length; fill(); }
    function openLb(id, all, from) {
      if (!lb) return;
      var src = all ? cards : list();
      lbList = src.filter(function (c) { return c.dataset.ph === '1'; });
      if (!lbList.length) lbList = cards.filter(function (c) { return c.dataset.ph === '1'; });
      lbI = Math.max(0, lbList.indexOf(byId[id]));
      lbFrom = from || document.activeElement;
      fill();
      document.documentElement.style.overflow = 'hidden';
      if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
    }
    if (lb) {
      $('[data-tav-lbx]', lb).addEventListener('click', function () { lb.close(); });
      $('[data-tav-lbp]', lb).addEventListener('click', function () { go(-1); });
      $('[data-tav-lbnx]', lb).addEventListener('click', function () { go(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        if (lbFrom && lbFrom.focus) lbFrom.focus({ preventScroll: true });
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      var sx = null, sy = 0;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      });
    }
  }

  function init() { $$('[data-tav]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
